export default __webpack_public_path__ + "static/media/neopreno-hombre.52f228ff.png";